import React from 'react';

function discription({ eleItem, handleInputChange, i, t }) {
  return (
    <>
      <input
        type="text"
        name="description"
        className="form-control text-bordered"
        value={eleItem.description}
        onChange={(e) => handleInputChange(e, eleItem, i)}
      />
      <span className="error-message">{eleItem?.errors?.includes('description') && t('CARE_LABELS.TABLE.DISCRIPTION.CARE_DESCRPTION')}</span>
    </>
  );
}
export default discription;
